import { http } from './http'
import { PaginationParams } from './map'
import { Admins } from '../../common/models'
import {
  Admin,
  AdminPayload,
  AdminUpdatePayload,
} from '../../common/models/general-settings'

export const getGeneralSettingsAdmins = (params?: PaginationParams) =>
  http.get<Admins[]>('/operations/super-admin', {
    params,
    headers: {},
  })

export const createGeneralSettingsAdmin = (data: AdminPayload) =>
  http.post('/operations/super-admin', data)

export const getGeneralSettingsAdminById = (id: string) =>
  http.get<Admin>(`/operations/super-admin/${id}`)

export const updateAdmin = (id: string, data: AdminUpdatePayload) =>
  http.put<Admin>(`/operations/super-admin/${id}`, data)
